import { dolosClient } from "lib/axios/clients";
import { REACT_APP_DOLOS_URL } from "resources/constants";

const trackDolosMixpanelRequest = async (data = {}) => {
  const config = {
    method: "POST",
    url: REACT_APP_DOLOS_URL,
    data,
  };

  dolosClient.request(config);
};

export default trackDolosMixpanelRequest;
